import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { autoaprendizadoSchema } from './autoaprendizado-schemas';

// Painel de qualidade do autoaprendizado (admin). Backend parseia os .learnings/
// + auditorias sincronizados; cache de 30s do lado servidor, então aqui staleTime alto.
export function useAutoaprendizado() {
  return useQuery({
    queryKey: ['agentes', 'autoaprendizado'] as const,
    queryFn: ({ signal }) =>
      api('/api/v2/agentes/autoaprendizado', { schema: autoaprendizadoSchema, signal }),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
